import { gql } from './graphql';

export interface YardGeometryProps {
  kind: 'boundary' | 'parking_spot';
  location: string | null;
  name: string | null;
  zone: string | null;
  flux_spot_id: string | null;
}

interface CampusGeographicFeatureRow {
  uuid: string;
  name: string;
  campusUuid: string;
  features: GeoJSON.FeatureCollection<GeoJSON.Geometry, YardGeometryProps> | null;
}

const CAMPUS_GEOGRAPHIC_FEATURES_BY_FACILITY_ID = `
  query CampusGeographicFeaturesByFacilityId($facilityId: ID!) {
    campusGeographicFeaturesByFacilityId(facilityId: $facilityId) {
      uuid
      name
      campusUuid
      features
    }
  }
`;

const geometryCache = new Map<
  number,
  Promise<GeoJSON.FeatureCollection<GeoJSON.Geometry, YardGeometryProps>>
>();

export function loadYardGeometry(
  facilityId: number
): Promise<GeoJSON.FeatureCollection<GeoJSON.Geometry, YardGeometryProps>> {
  let cached = geometryCache.get(facilityId);
  if (!cached) {
    cached = gql<{
      campusGeographicFeaturesByFacilityId: CampusGeographicFeatureRow[] | null;
    }>(CAMPUS_GEOGRAPHIC_FEATURES_BY_FACILITY_ID, { facilityId }).then((data) => ({
      type: 'FeatureCollection' as const,
      features: (data.campusGeographicFeaturesByFacilityId || []).flatMap(
        (row) => row.features?.features ?? []
      )
    }));
    geometryCache.set(facilityId, cached);
  }
  return cached;
}
